module.exports = __webpack_public_path__ + "static/media/29820013-OsR0wSgs.4896bf99.JPG";